"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiRouterSwitch = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
function UiRouterSwitch({ pages }) {
    if (pages.length === 0) {
        return null;
    }
    return (react_1.default.createElement(react_router_dom_1.Switch, null,
        pages.map((Page) => (react_1.default.createElement(react_router_dom_1.Route, { path: Page.route, key: Page.route },
            react_1.default.createElement(Page, null)))),
        react_1.default.createElement(react_router_dom_1.Redirect, { to: pages[0].route })));
}
exports.UiRouterSwitch = UiRouterSwitch;
